export const contactSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Denis Bitter",
  "url": "https://www.denisbitter.de",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.denisbitter.de/images/b_gray.png"
  },
  "email": "saghallo@denisbitter.de",
  "telephone": "+49 151 53 23 17 91",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Hamburg",
    "addressCountry": "DE"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+49 151 53 23 17 91",
    "contactType": "Customer Support",
    "areaServed": "DE",
    "availableLanguage": ["de"]
  },
  "sameAs": [
    "https://www.instagram.com/denisbitter",
    "https://www.linkedin.com/in/denisbitter",
    "https://www.facebook.com/denisbitter",
    "https://www.youtube.com/@densibitterfullstack",
    "https://www.tiktok.com/@theoriginalbitter",
    "https://x.com/theoriginalbitter"
  ]
};
